export const PartnerIntegrationFormState = {
    data: {
        partner_id: '',
        external_branch_id: '',
        external_group_menu_id: '',
        restaurant_id: '',
        branch_id: '',
    },
}